module.exports = __webpack_public_path__ + "img/video-disabled.d9698a8a.svg";